var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "archived-contracts container container_30" },
    [
      _c("searcher", { on: { "compose-filters": _vm.loadFilteredContracts } }),
      _vm._v(" "),
      _c(
        "md-table",
        { staticClass: "archived-contracts__table" },
        [
          _vm.list.length
            ? [
                _c(
                  "md-table-row",
                  { staticClass: "archived-contracts_row" },
                  [
                    _c("md-table-head", [
                      _vm._v(_vm._s(_vm.i18n.cont_counterparty()))
                    ]),
                    _vm._v(" "),
                    _c("md-table-head", [
                      _vm._v(_vm._s(_vm.i18n.cont_contract_number()))
                    ]),
                    _vm._v(" "),
                    _c("md-table-head", [
                      _vm._v(_vm._s(_vm.i18n.lbl_start_date()))
                    ]),
                    _vm._v(" "),
                    _c("md-table-head", [
                      _vm._v(_vm._s(_vm.i18n.lbl_end_date()))
                    ]),
                    _vm._v(" "),
                    _c("md-table-head")
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.list, function(item, i) {
                  return [
                    _c(
                      "md-table-row",
                      { key: i, staticClass: "archived-contracts__row" },
                      [
                        _c(
                          "md-table-cell",
                          {
                            staticClass:
                              "archived-contracts__table-cell counterparty-cell"
                          },
                          [
                            _c("company-name-getter", {
                              attrs: { id: item.contractor }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "md-table-cell",
                          {
                            staticClass:
                              "archived-contracts__table-cell contract-number-cell"
                          },
                          [_vm._v(_vm._s(item.contractNumber))]
                        ),
                        _vm._v(" "),
                        _c(
                          "md-table-cell",
                          { staticClass: "archived-contracts__table-cell" },
                          [_vm._v(_vm._s(_vm.i18n.d(item.startDate)))]
                        ),
                        _vm._v(" "),
                        _c(
                          "md-table-cell",
                          { staticClass: "archived-contracts__table-cell" },
                          [_vm._v(_vm._s(_vm.i18n.d(item.endDate)))]
                        ),
                        _vm._v(" "),
                        _c(
                          "md-table-cell",
                          { staticClass: "archived-contracts__table-cell" },
                          [
                            _c(
                              "md-button",
                              {
                                staticClass:
                                  "contract-requests__view-details-btn md-icon-button",
                                on: {
                                  click: function($event) {
                                    return _vm.openDetails(item.id)
                                  }
                                }
                              },
                              [_c("md-icon", [_vm._v("keyboard_arrow_right")])],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }),
                _vm._v(" "),
                !_vm.isLoaded
                  ? _c(
                      "md-table-row",
                      [
                        _c("md-table-cell", { attrs: { colspan: "7" } }, [
                          _c(
                            "div",
                            { staticClass: "archived-contracts__btn-outer" },
                            [
                              _c(
                                "md-button",
                                {
                                  attrs: { disabled: _vm.isLoading },
                                  on: { click: _vm.more }
                                },
                                [_vm._v(_vm._s(_vm.i18n.lbl_view_more()))]
                              )
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ]
            : [
                _c(
                  "div",
                  { staticClass: "archived-contracts__no-contracts" },
                  [
                    _c("md-icon", { staticClass: "md-size-4x" }, [
                      _vm._v("trending_up")
                    ]),
                    _vm._v(" "),
                    _c("h2", [
                      _vm._v(_vm._s(_vm.i18n.cont_no_archived_contracts()))
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(_vm._s(_vm.i18n.cont_no_archived_contracts_desc()))
                    ])
                  ],
                  1
                )
              ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5fae1516", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fae1516","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/contracts/index/archive/Contracts.ArchivedList.vue
// module id = p1rp
// module chunks = 1